export const LOGIN_PATH = '/login';
export const VERIFY_EMAIL_PATH = '/verify-email';
